/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerMock { 
    enable: boolean;
    mockType: CustomerMock.MockTypeEnum;
}
export namespace CustomerMock {
    export type MockTypeEnum = 'Success' | 'IdNotFound' | 'IdNoMatch';
    export const MockTypeEnum = {
        Success: 'Success' as MockTypeEnum,
        IdNotFound: 'IdNotFound' as MockTypeEnum,
        IdNoMatch: 'IdNoMatch' as MockTypeEnum
    };
}


